const WORKFLOW_MANAGER_ROLES = new Set([
  'founder',
  'director',
  'admin',
  'hr head',
  'hr admin',
  'manager',
]);

export const normalizeWorkflowRole = (role?: string | null): string =>
  (role || 'employee').trim().toLowerCase();

export const canManageWorkflow = (role?: string | null): boolean =>
  WORKFLOW_MANAGER_ROLES.has(normalizeWorkflowRole(role));

/** Manage on a Work Monitor panel. With an Access profile the grid decides
 *  (an intern given Manage gets it, a manager without it does not), the same
 *  as TeamLio; the role list above is only the fallback for a viewer with no
 *  profile, where canManage() would say yes to everyone. */
export const canManageWorkflowPanel = (
  panel: string,
  role: string | null | undefined,
  access: { hasAccess: boolean; canManage: (key: string) => boolean },
): boolean => (access.hasAccess ? access.canManage(panel) : canManageWorkflow(role));

export const canViewWorkflowActivity = (_role?: string | null): boolean => true;
